export const DESIGNATION_PERMISSIONS = {
  // Business Development
  'Business Developer Executive': {
    modules: ['sales', 'projects', 'workflow'],
    restrictions: ['office', 'reports', 'accounts','schedule_tasks']
  },
  'Business Developer Head': {
    modules: ['sales', 'projects', 'workflow', 'reports','accounts'],
    restrictions: ['office','schedule_tasks']
  },
  
  // Content Team
  'Content Writer': {
    modules: ['projects', 'workflow'],
    restrictions: ['sales', 'office', 'accounts', 'reports','schedule_tasks']
  },
  'Creative Head': {
    modules: ['projects', 'workflow'],
    restrictions: ['sales', 'accounts','office','reports','schedule_tasks']
  },
  
  // Development Team
  'Junior Developer': {
    modules: ['projects', 'workflow'],
    restrictions: ['sales', 'office', 'accounts', 'reports','schedule_tasks']
  },
  'Senior Developer': {
    modules: ['projects', 'workflow'],
    restrictions: ['sales', 'accounts','office','reports','schedule_tasks']
  },
  'Project Head': {
    modules: ['projects', 'workflow', 'reports','sales', 'accounts','office','schedule_tasks'],
    restrictions: []
  },
  
  // Management
  'Chief Executive Officer': {
    modules: ['all'],
    restrictions: []
  },
  'HR & Finance': {
    modules: ['all'],
    restrictions: []
  },
  
  // Marketing
  'Digital Marketing Head': {
    modules: ['projects', 'workflow', 'reports'],
    restrictions: ['sales', 'accounts', 'office','schedule_tasks']
  },
  'Performance Marketer': {
    modules: ['projects', 'workflow'],
    restrictions: ['sales', 'office', 'accounts', 'reports','schedule_tasks']
  },
  
  // Content Strategy
  'Senior Content Strategist': {
    modules: ['projects', 'workflow'],
    restrictions: ['sales', 'accounts', 'office', 'reports','schedule_tasks']
  },
  
  // Video
  'Video Editor': {
    modules: ['projects', 'workflow'],
    restrictions: ['sales', 'office', 'accounts', 'reports','schedule_tasks']
  }
};